import Container from "@components/Container/Container";

/**
 * Component to render Description of SBA on homepage
 */
const SBADescription = (): React.ReactElement => {
  return (
    <Container
      rootClassName="flex flex-row justify-center px-0"
      data-testid="sba-description-component"
    >
      <div className="mb-6 flex w-full flex-col justify-center pl-3 text-center text-gray-850 md:pl-4 lg:w-11/12 lg:flex-row">
        <div className="w-full lg:w-4/12 lg:pr-4">
          <h2 className="mb-6 text-left font-poppins text-xl font-medium md:mb-2 md:mb-6 lg:mb-0 lg:pl-3 lg:text-8xl lg:leading-tight">
            {"Singapore "}
            <br className="hidden lg:inline" />
            {"Business "}
            <br className="hidden lg:inline" />
            {"Awards "}
          </h2>
        </div>

        <div className="w-full text-left lg:w-8/12">
          <p className="text-md pl-0 font-public-sans leading-6">
            {
              "The Singapore Business Awards (SBA) is jointly organised by The Business Times, a business daily published by SPH Media Limited, and DHL, the global market leader of the international express and logistics industry."
            }
          </p>
        </div>
      </div>
    </Container>
  );
};

export default SBADescription;
